import { formatDateRu } from "../../../utils/appointmentLabels";

/** Статус согласия на ПДн: принято + дата или «не принято». */
export function formatConsentPdLabel(consentPd, consentPdAt) {
  if (!consentPd) return "Не принято";
  if (!consentPdAt) return "Принято";
  const formatted = formatDateRu(consentPdAt, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  return formatted ? `Принято · ${formatted}` : "Принято";
}

export default function ConsentPdStatus({
  consentPd,
  consentPdAt,
  className,
  showHint = true,
}) {
  return (
    <div className={className}>
      <strong>Согласие на обработку ПДн</strong>
      <div>{formatConsentPdLabel(consentPd, consentPdAt)}</div>
      {showHint ? (
        <p className="consentPdHint">
          Клиент принимает при регистрации по ссылке или в личном кабинете
        </p>
      ) : null}
    </div>
  );
}
